import {
    ODataHeader,
    ODataString,
    ODataDecimal,
    ODataInteger,
    HeaderAlignment
} from "pbas-vue-components";
import { translate2 } from '../trans2'

const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

const RemittancesHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        type: new ODataString("BillingTerm/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        type: new ODataString("BillingTerm/Translations[]/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.term",
        type: new ODataString("BillingTerm/Translations[]/Name", {
          getString: (item) => translate2(item.BillingTerm, "Name")
        }),
        sortable: true,
        visible: true,
        searchable: true,
        version: 2,
        orderByKey: "BillingTerm/StartDate",
        allowVisibilityChange: true,
        subHeaders: [
            new ODataHeader({
                type: new ODataInteger("BillingTerm/Number"),
                visible: false,
                allowVisibilityChange: false,
                searchable:false
            }),
            new ODataHeader({
                title: "globals.term",
                type: new ODataString("BillingTerm/Translations[]/Name", {
                  getString: (item) => translate2(item.BillingTerm, "Name")
                }),
                visible: false,
                allowVisibilityChange: false,
              }),
        ]
      }),
      new ODataHeader({
        title: "globals.term",
        type: new ODataString("BillingTerm/Name"),
        sortable: true,
        visible: false,
        searchable: true,
        version: 2,
        allowVisibilityChange: false,
      }),
    // new ODataHeader({
    //     title: "globals.term",
    //     type: new ODataString("BillingTerm/Name"),
    //     visible: true,
    //     allowVisibilityChange: true,
    //     searchable: true,
    //     version: 2,
    //     orderByKey: "BillingTerm/StartDate",
    //     subHeaders: [
    //         new ODataHeader({
    //             type: new ODataInteger("BillingTerm/Number"),
    //             visible: false,
    //             allowVisibilityChange: false
    //         })
    //     ]
    // }),
    new ODataHeader({
        title: "globals.certificate",
        type: new ODataString("Member/SINCERT"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "globals.firstname",
        type: new ODataString("Member/FirstName"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        title: "globals.lastname",
        type: new ODataString("Member/LastName"),
        sortable: true,
        visible: true,
        searchable: true,
    }),
    new ODataHeader({
        type: new ODataString("Coverage/Name"),
        sortable: true,
        visible: false,
        searchable: true,
        version: 1
      }),
      new ODataHeader({
        type: new ODataString("Coverage/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "globals.coverage",
      type: new ODataString("Coverage/Translations[]/Name", {
          getString: (item) => translate2(item.Coverage, "Name")
        }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1,
      orderByKey: "Coverage/Name"
    }),
    new ODataHeader({
        type: new ODataString("TrustFund/Name"),
        sortable: true,
        visible: false,
        searchable: true,
        version: 1
    }),
    new ODataHeader({
        type: new ODataString("TrustFund/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "components.getreports.trust_fund",
      type: new ODataString("TrustFund/Translations[]/Name", {
          getString: (item) => translate2(item.TrustFund, "Name")
        }),
      sortable: true,
      visible: true,
      searchable: true,
      version: 1,
      orderByKey: "TrustFund/Name"
    }),
    new ODataHeader({
        title: "components.plancreationwizard.volume",
        type: new ODataDecimal("Volume", {
            getString: (item, type) => {
                const value = item.Value;
                if (value === null || value === undefined) {
                    return "";
                }
                if (typeof value !== "number") {
                    return value;
                }
                return formatter.format(value);
            },
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "headers.remittances.remittance_amount",
        type: new ODataDecimal("Amount", {
            getString: (item, type) => {
                const value = item.Amount;
                if (value === null || value === undefined) {
                    return "";
                }
                if (typeof value !== "number") {
                    return value;
                }
                return formatter.format(value);
            },
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
      title: "headers.adjustments.PPTax",
      type: new ODataDecimal("PPTax", {
        getString: (item, type) => {
          const value = item.PPTax;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.adjustments.RSTax",
      type: new ODataDecimal("RSTax", {
        getString: (item, type) => {
          const value = item.RSTax;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.adjustments.GSTax",
      type: new ODataDecimal("GSTax", {
        getString: (item, type) => {
          const value = item.GSTax;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.adjustments.PSTax",
      type: new ODataDecimal("PSTax", {
        getString: (item, type) => {
          const value = item.PSTax;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "headers.adjustments.HSTax",
      type: new ODataDecimal("HSTax", {
        getString: (item, type) => {
          const value = item.HSTax;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true
    }),
];
export default RemittancesHeaders;